import { NgModule } from "@angular/core";

import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home.component";
import { TranslateModule } from "@ngx-translate/core";
import { FuseSharedModule } from "@fuse/shared.module";
import { SharedModule } from "@app/shared/shared.module";
import { MatButtonModule } from "@angular/material/button";
import { FuseCardModule } from '@fuse/components/card';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [HomeComponent],
    imports: [
        MatButtonModule,
        MatSelectModule,
        MatCardModule,
        MatIconModule,
        TranslateModule,
        FuseSharedModule,
        FuseCardModule,

        SharedModule,

        HomeRoutingModule,
    ],
})
export class HomeModule {}
